import { TLandStatus } from '@cian/api-models/offer-card/v1/get-offer-data';

type textLandStatusListType = { [index in TLandStatus]?: string };

const text: textLandStatusListType = {
  farm: 'Фермерское хозяйство',
  forAgriculturalPurposes: 'Участок сельскохозяйственного назначения',
  forestArea: 'Участок лесного фонда',
  gardening: 'Садоводство',
  gardeningNonProfitPartnership: 'Садовое некоммерческое товарищество',
  individualHousingConstruction: 'Индивидуальное жилищное строительство',
  industrialLand: 'Земля промышленного назначения',
  industryTransportCommunications: 'Земли промышленности',
  investmentProject: 'Инвестпроект',
  ofProtectedCategories: 'Особо охраняемых категорий',
  privateFarm: 'Личное подсобное хозяйство',
  reserve: 'Участок запаса',
  settlements: 'Участок поселений',
  suburbanNonProfitPartnership: 'Дачное некоммерческое партнерство',
  suburbanNonProfitSettlementsPartnership: 'Дачное некоммерческое партнерство поселений',
  waterArea: 'Участок водного фонда',
};

export function getLandStatusText(index: TLandStatus) {
  return text[index];
}
